import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {TrackballControls} from "three/examples/jsm/controls/TrackballControls";

export function orbitCtrl(camera, domElement){
    let controls = new OrbitControls(camera, domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.3;
    controls.enableZoom = false;
    return controls;
}

export function trackballCtrl(camera, domElement){
    let controls = new TrackballControls(camera, domElement);
    controls.noRotate = true;
    controls.noZoom = false;
    controls.noPan = true;
    controls.zoomSpeed = 1.5;
    controls.dynamicDampingFactor = 0.4; // set dampening factor
    controls.maxDistance = 2200; //缩放限制
    controls.minDistance = 10;
    return controls;
}
